import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

const MOVE_IN_DATE = '2020-09-30';

export function isBeforePromoDate(startDate = ''): boolean {
  return dayjs(startDate).isSameOrBefore(MOVE_IN_DATE);
}
